// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Action imports
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
import { setYAxisMetric } from './y-axis-metric.actions';
export const yAxisMetric = createReducer('', on(setScatterPlot, (state, action) => {
    return action.scatterPlot.yAxisMetric;
}), on(setYAxisMetric, (state, { metricId }) => {
    return metricId;
}));
